export interface HDEProfessionalProfile {
    ID: string | number;
    Title?: string | null;
    URLSegment?: string | null;
    Website?: string | null;
    PrimaryDomain?: string | null;
    BusinessFocus?: string | null;
    ServiceableAreasCount?: number | null;
    LibraryLocationsCount?: number | null;
}

interface HDEProfileCompletionArgs {
    profile: HDEProfessionalProfile | null;
    memberFirstName?: string | null;
    memberLastName?: string | null;
    memberEmail?: string | null;
}

/**
 * Determine whether the selected profile already has enough data to skip
 * additional business questions in the HDE registration flow.
 */
export function getHDEProfileCompletion({
    profile,
    memberFirstName,
    memberLastName,
    memberEmail,
}: HDEProfileCompletionArgs) {
    const hasMemberDetails = Boolean(
        memberFirstName?.trim() &&
        memberLastName?.trim() &&
        memberEmail?.trim(),
    );
    const hasCompanyDetails = Boolean(
        profile?.Title?.trim() &&
        (profile?.Website?.trim() || profile?.PrimaryDomain?.trim()),
    );
    const hasIndustryInfo = Boolean(
        profile?.BusinessFocus && profile.BusinessFocus !== 'Unspecified',
    );
    const hasLocationInfo =
        (profile?.ServiceableAreasCount ?? 0) > 0 ||
        (profile?.LibraryLocationsCount ?? 0) > 0;

    return {
        hasMemberDetails,
        hasCompanyDetails,
        hasIndustryInfo,
        hasLocationInfo,
        canSkipCompanyDetails: hasMemberDetails && hasCompanyDetails,
        canAutoSubmit:
            hasMemberDetails &&
            hasCompanyDetails &&
            hasIndustryInfo &&
            hasLocationInfo,
    };
}
